import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import SurveyQuestion from '../tags/AFS/SurveyQuestion'
import InfoGraphic from '../tags/AFS/InfoGraphic'
import { connect } from 'react-redux'

import {
  getSurveyTemplate,
  submitSurvey,
  getSubmittedSurvey
} from '../../services/vu'

import { ArrowForward, ArrowBack } from '@mui/icons-material';

import { getProperty } from '../../helpers/properties';
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse } }) => {
  return {
    locationCode: selectedCourse.locationCd
  }
}

export class StudentSurvey extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentQuestion: undefined,
      formData: [],
      originalFormData: [],
      surveyTemplate: undefined,
      pageReady: false,
      surveyComplete: false,
      errorMsg: false,
      surveyId: undefined,
      templateId: getProperty("successSurveyTemplateId"),
      submitLoading: false,
      showInfoGraphic: false,
      studyLoad: 'FULL TIME',
      submittingSurvey: false
    }
    this.calculateCurrentQuestion = this.calculateCurrentQuestion.bind(this)
    this.convertToFormData = this.convertToFormData.bind(this)
    this.mapAnswers = this.mapAnswers.bind(this)
    this.partialSurveySubmit = this.partialSurveySubmit.bind(this)
  }

  componentDidMount = () => {
    getSurveyTemplate(this.state.templateId, this.props.locationCode).then(
      x => {
        if (x.survey !== null) {
          getSubmittedSurvey(x.survey.id).then(y => {
            if (y.content !== null) {
              this.setState({
                surveyTemplate: x,
                surveyId: x.survey.id,
                studyLoad: x.survey.studyLoad,
                pageReady: true,
                currentQuestion:
                  y.content.hasOwnProperty('submittedAnswers') &&
                  y.content.submittedAnswers.length > 0
                    ? this.calculateCurrentQuestion(
                        y.content.submittedAnswers,
                        x.content
                      )
                    : 0,
                formData:
                  y.content.hasOwnProperty('submittedAnswers') &&
                  y.content.submittedAnswers.length > 0
                    ? this.convertToFormData(y.content.submittedAnswers)
                    : [],
                originalFormData: y.content.hasOwnProperty('submittedAnswers') &&
                y.content.submittedAnswers.length > 0
                  ? this.convertToAnsweredQuestions(y.content.submittedAnswers)
                  : [],
              })
            } else {
              this.props.history.push(getConfiguration('baseUrl') + '/afs/results')
            }
          })
        } else if (x.advisor !== null) {
          this.props.history.push(getConfiguration('baseUrl') + '/afs/results')
        } else {
          alert('Unable to access the Advising for Success survey.')
          this.props.history.push(getConfiguration('baseUrl'))
        }
      }
    )
  }

  calculateCurrentQuestion = (prevQuestions, content) => {
    if (!content || !Array.isArray(content.questionGroup)) return 0;
  
    const answeredIds = prevQuestions.map(q => q.id);
  
    for (let i = 0; i < content.questionGroup.length; i++) {
      const group = content.questionGroup[i];
      if (!answeredIds.includes(group.id)) {
        return i; // index of the next unanswered group
      }
    }
    return content.questionGroup.length;
  };

  convertToAnsweredQuestions = formData => {
    let answeredQuestions = []

    formData.forEach((item, index) => {
      answeredQuestions.push({
        id: item.id,
        answers: this.extractAnswers(item.questions)
      })
    })
    return answeredQuestions
  }

  convertToFormData = preAnswers => {
    let formData = []
    preAnswers.forEach((item, index) => {
      formData.push({
        questionNumber: index,
        valid: true,
        id: item.id,
        questions: this.mapAnswers(item.questions),
        answers: this.extractAnswers(item.questions)
      })
    })
    return formData
  }

  extractAnswers = questionsArray => {
    return questionsArray.map(item => {
      return item.answerOptions[0]
    })
  }

  mapAnswers = questionsArray => {
    return questionsArray.map(item => {
      let copy = Object.assign({}, item)
      copy.answers = copy.answerOptions
      return copy
    })
  }

  areAnswersEqual = (a1 = [], a2 = []) => {
    if (a1.length !== a2.length) return false;
  
    const ids1 = a1.map(a => a.id).sort();
    const ids2 = a2.map(a => a.id).sort();
  
    return ids1.every((id, i) => id === ids2[i]);
  };

  manageFormData = data => {
    let newFormData = this.state.formData ? this.state.formData : []
    let foundItemToUpdate = newFormData.find((x, i) => {
      return x.questionNumber === data.questionNumber
    })

    if (foundItemToUpdate) {
      newFormData
        .sort((a, b) => {
          return a.questionNumber - b.questionNumber
        })
        .map((x, i) => {
          if (data.questionNumber === x.questionNumber) {
            return newFormData.splice(i, 1, data)
          }
        })
    } else {
      newFormData.push(data)
    }
    this.setState({ formData: newFormData })
  }

  answerHasChanged = (originalFormData, answeredQuestions) => {
    const originalMap = new Map(originalFormData.map(item => [item.id, item]));
  
    for (const item of answeredQuestions) {
      const originalItem = originalMap.get(item.id);
      if (!originalItem || !this.areAnswersEqual(originalItem.answers, item.answers)) {
        return true;
      }
    }
  
    return false;
  };

  partialSurveySubmit = () => {
    if (!this.state.submittingSurvey && this.state.pageReady) {
      this.setState({ submittingSurvey: true })
      let answeredQuestions = this.slimFormDataSubmission();

      if(this.answerHasChanged(this.state.originalFormData, answeredQuestions)) {
        submitSurvey(this.state.surveyId, answeredQuestions, '1')
          .then(x => {
            if (
              x.data.status === 'error' &&
              x.data.msg === 'Survey is already submitted'
            ) {
              this.props.history.push(getConfiguration('baseUrl') + '/afs/results')
            } 
          })
          .finally(() => {
            const updatedFormData = [...this.state.originalFormData];

            answeredQuestions.forEach(newAnswer => {
              const index = updatedFormData.findIndex(item => item.id === newAnswer.id);
              if (index !== -1) {
                updatedFormData[index] = newAnswer;
              } else {
                updatedFormData.push(newAnswer);
              }
            });

            this.setState({ 
              submittingSurvey: false, 
              currentQuestion: this.state.currentQuestion + 1,
              originalFormData: updatedFormData
            });
          }
        )
      } else {
        this.setState({ 
          submittingSurvey: false, 
          currentQuestion: this.state.currentQuestion + 1
        })
      }
    }
  }

  postData = e => {
    if (e) {
      e.preventDefault()
    }

    let questionObj = this.slimFormDataSubmission()

    submitSurvey(this.state.surveyId, questionObj, '3').then(x => {
      sessionStorage.removeItem('AFS_template')
      this.setState({ submitLoading: true })
      this.props.history.push(getConfiguration('baseUrl') + '/afs/results')
    })
  }

  slimFormDataSubmission = () => {
    const questionObj = [];
    const questionsToSubmit = this.state.formData.filter(
      x => x.questionNumber === this.state.currentQuestion
    );
  
    questionsToSubmit.forEach(x => {
      if (x.questions) {
        x.questions.forEach(z => {
          questionObj.push({ id: z.id, answers: z.answers });
        });
      } else {
        questionObj.push({ id: x.id, answers: x.answers });
      }
    });
  
    return questionObj;
  }

  scrollTop = () => {
    var element = document.getElementById('survey-header')
    element.scrollIntoView({
      behavior: 'smooth'
    })
  }

  formValidation = questionNumber => {
    if (this.state.formData) {
      var valid = false
      this.state.formData.map(x => {
        if (x.questionNumber === questionNumber) {
          valid = x.valid
        }
      })
      return valid
    }
    return false
  }

  startSurvey = () => {
    if (this.state.pageReady) {
      this.setState({
        currentQuestion: 0
      })
    }
    return
  }

  nextButton = e => {
    e.preventDefault()
    if (this.formValidation(this.state.currentQuestion)) {
      this.setState({ errorMsg: false },
        () => {
          this.scrollTop()
          this.partialSurveySubmit()
        }
      )
    } else {
      this.setState({ errorMsg: true })
    }
    return
  }

  backButton = e => {
    e.preventDefault()
    this.setState(
      {
        currentQuestion: this.state.currentQuestion - 1,
        errorMsg: false
      },
      () => {
        this.scrollTop()
      }
    )
  }

  submit = data => {
    if (this.formValidation(this.state.currentQuestion)) {
      this.postData()

      this.setState({
        surveyComplete: true,
        errorMsg: false,
        submitLoading: true
      })
    } else {
      this.setState({ errorMsg: true })
    }
    return
  }

  backgroundImage = () => {
    let surveyBg = ['survey-wrapper']

    if (this.state.currentQuestion) {
      if (this.state.currentQuestion === 4) {
        surveyBg.push('blue')
      } else {
        if (this.props.locationCode === 'BR') {
          surveyBg.push('br-survey-background--' + (this.state.currentQuestion % 13))
        } else if (this.props.locationCode === 'SY') {
          surveyBg.push(
            'sy-survey-background--' + (this.state.currentQuestion % 13)
          )
        } else {
          surveyBg.push(
            'survey-background--' + (this.state.currentQuestion % 13)
          )
        }
      }
    }

    return surveyBg.join(' ')
  }

  topText = () => {
    var startText = this.state.pageReady ? 'Start' : 'Loading...'
    if (
      this.state.currentQuestion === undefined &&
      !this.state.surveyComplete
    ) {
      return (
        <div className="intro-text-wrapper">
          <h1 className="intro-header">JOURNEY TO SUCCESS</h1>
          <h4>Every successful journey starts with a plan</h4>
          <p>
            At VU we care about your success and want to help you build a
            personalised plan to achieve your goals at university and beyond.
          </p>
          <p>
            We have developed a brief series of questions for you to get you on
            your way. Once you have completed these questions, we will provide
            you with your Success Plan, containing valuable information and
            resources to help you drive your own success.
          </p>
          <p>
            You will also be introduced to your Student Advisor who will be
            available to help guide you throughout your journey.
          </p>
          <br />
          <div className="btn-wrapper">
            <a
              className="btn btn-primary btn-lg"
              href="#"
              onClick={this.startSurvey}
            >
              {startText}
            </a>
          </div>
        </div>
      )
    }
    return undefined
  }

  getQuestions = number => {
    return this.state.formData
      .filter(x => number === x.questionNumber)
      .map(item => item.questions)
  }

  surveyQuestions = (data, formData) => {
    if (data) {
      var sortedData = data.content.questionGroup.sort((a, b) => a.orderDisplay - b.orderDisplay)
      var sortedFormData = formData.sort((a, b) => a.questionNumber - b.questionNumber)

      var output = sortedData.map((x, i) => {
        let prepop =
          sortedFormData.find(form => {
            return form.id === x.id
          }) || {}

        return (
          <SurveyQuestion
            key={`student-survey-${i}`}
            questionNumber={i}
            active={this.state.currentQuestion === i ? true : false}
            data={x}
            manageFormData={this.manageFormData}
            prepop={prepop}
          />
        )
      })
      return output
    }
  }

  questionListTotal = data => {
    if (data) {
      return data.content.questionGroup.length
    }
  }

  render() {
    var surveyClass =
      this.state.currentQuestion >= 0
        ? 'survey-wrapper-sub active'
        : 'survey-wrapper-sub'
    var headerClass =
      this.state.currentQuestion >= 0
        ? 'survey-home-link inner'
        : 'survey-home-link'
    var errorMsgClass = this.state.errorMsg ? 'error-msg active' : 'error-msg'
    var questionListTotal = this.questionListTotal(this.state.surveyTemplate)
    var submitText = this.state.submitLoading ? 'Loading...' : 'Submit'

    return (
      <div className={this.backgroundImage()}>
        <div className={surveyClass}>
          <div className="survey-header" id="survey-header">
            <NavLink className={headerClass} to={getConfiguration('baseUrl')}>
              <ArrowBack />
              <span className="logo">Logo</span>
            </NavLink>
          </div>

          {this.topText()}

          <div className="survey-question-wrapper">
            {this.surveyQuestions(
              this.state.surveyTemplate,
              this.state.formData
            )}
            <p className={errorMsgClass}>Please select an option above.</p>
            <div className="button-wrapper">
              {this.state.currentQuestion < questionListTotal ? (
                <p className="question-count">
                  {this.state.currentQuestion + 1}/{questionListTotal}
                </p>
              ) : (
                undefined
              )}
              {this.state.currentQuestion === questionListTotal - 1 ? (
                <a
                  className="btn btn-primary btn-lg next"
                  onClick={this.submit}
                  href="#"
                >
                  {submitText}
                </a>
              ) : (
                undefined
              )}
              {this.state.currentQuestion < questionListTotal - 1 ? (
                <a
                  className="btn btn-primary btn-lg next"
                  href="#"
                  onClick={this.nextButton}
                >
                  Next <ArrowForward />
                </a>
              ) : (
                undefined
              )}
              {this.state.currentQuestion > 0 ? (
                <a
                  className="btn btn-primary btn-lg back"
                  href="#"
                  onClick={this.backButton}
                >
                  <ArrowBack /> Back
                </a>
              ) : (
                undefined
              )}
            </div>
          </div>
        </div>
        {this.state.currentQuestion === 4 ? (
          <InfoGraphic
            studyLoad={this.state.studyLoad}
            formAnswers={this.getQuestions(4)[0]}
          />
        ) : (
          undefined
        )}
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(StudentSurvey))
